import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../../supabase/supabase';
import { assets } from '../../data/catalog';
import './admin.css';

const ADMIN_EMAIL = 'admin@dekka.lk';

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(async ({ data: { session } }) => {
      if (!session) return;
      if (session.user.email?.toLowerCase() === ADMIN_EMAIL) {
        navigate('/admin');
      } else {
        await supabase.auth.signOut();
      }
    });
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (email.trim().toLowerCase() !== ADMIN_EMAIL) {
      setError('This account is not authorized to access the admin panel.');
      setLoading(false);
      return;
    }

    const { data, error: loginError } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password
    });

    if (loginError) {
      setError(loginError.message);
    } else if (data.user?.email?.toLowerCase() !== ADMIN_EMAIL) {
      await supabase.auth.signOut();
      setError('This account is not authorized to access the admin panel.');
    } else {
      navigate('/admin');
    }

    setLoading(false);
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-brand">
          <img
            src={assets.logo}
            alt="Darshana Global Enterprises"
            style={{ width: '190px', height: '84px', objectFit: 'contain', display: 'block', margin: '0 auto 14px' }}
          />
          <h1>Darshana Admin</h1>
          <p>Sign in to manage your store</p>
        </div>
        {error && <div className="admin-login-error">{error}</div>}
        <form onSubmit={handleLogin}>
          <label>Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="enter email" required />
          <label>Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••" required />
          <button className="admin-login-btn" type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;